import { DialogTrigger, DialogTriggerProps } from "react-aria-components";
import { AnimationState, ModalContext } from "./types";
import { useEffect, useState } from "react";
import { AnimationDefinition } from "framer-motion";

export default function ModalTrigger(props: DialogTriggerProps) {
  const [animation, setAnimation] = useState<AnimationState>("unmounted");

  function onComplete(animation: AnimationDefinition) {
    setAnimation((a) =>
      animation === "hidden" && a === "hidden" ? "unmounted" : a,
    );
  }

  useEffect(() => {
    if (props.isOpen !== undefined) onOpenChange(props.isOpen);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- onOpenChange is a consumer callback and is not memoised by callers
  }, [props.isOpen]);

  function onOpenChange(isOpen: boolean) {
    setAnimation(isOpen ? "visible" : "hidden");
    props.onOpenChange?.(isOpen);
  }

  return (
    <ModalContext.Provider
      value={{
        animation,
        onComplete,
        isOpen: props.isOpen,
      }}
    >
      <DialogTrigger {...props} onOpenChange={onOpenChange} />
    </ModalContext.Provider>
  );
}
